/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureIndicator = exports.DurationUnit = exports.CycleType = exports.BrowserBehaviour = exports.Action = void 0;
var Action;
(function (Action) {
    Action["PURCHASE"] = "PURCHASE";
    Action["UPGRADE"] = "UPGRADE";
    Action["CHANGE_PLAN"] = "CHANGE_PLAN";
    Action["CANCEL"] = "CANCEL";
    Action["MANAGE"] = "MANAGE";
    Action["ASSIGN"] = "ASSIGN";
    Action["UNASSIGN"] = "UNASSIGN";
    Action["UPDATE_PAYMENT_METHOD"] = "UPDATE_PAYMENT_METHOD";
    Action["CONNECT"] = "CONNECT";
})(Action = exports.Action || (exports.Action = {}));
var BrowserBehaviour;
(function (BrowserBehaviour) {
    BrowserBehaviour["OPEN_IN_SAME_TAB"] = "OPEN_IN_SAME_TAB";
    BrowserBehaviour["OPEN_IN_NEW_TAB"] = "OPEN_IN_NEW_TAB";
    BrowserBehaviour["OPEN_IN_POPUP"] = "OPEN_IN_POPUP";
})(BrowserBehaviour = exports.BrowserBehaviour || (exports.BrowserBehaviour = {}));
var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType = exports.CycleType || (exports.CycleType = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
var FailureIndicator;
(function (FailureIndicator) {
    FailureIndicator["UNKNOWN"] = "UNKNOWN";
    FailureIndicator["PRODUCT_NOT_EXISTS"] = "PRODUCT_NOT_EXISTS";
    FailureIndicator["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    FailureIndicator["CYCLE_NOT_SUPPORTED"] = "CYCLE_NOT_SUPPORTED";
    FailureIndicator["PRODUCT_TYPE_NOT_EXISTS"] = "PRODUCT_TYPE_NOT_EXISTS";
})(FailureIndicator = exports.FailureIndicator || (exports.FailureIndicator = {}));
//# sourceMappingURL=types.js.map